import { imageCompresser } from '@/commonFunctions/utils'
import { BASE_API_URL } from '@/constants/Common'
import { CsvTemplateId, GetCsvTemplateResponse } from '@/types'
import { useQuery } from '@tanstack/react-query'
import httpService from './httpService'
import { AxiosError } from 'axios'

export enum CsvTemplateQueryKeys {
  GET_CSV_TEMPLATE = 'get_csv_template',
}

export const useGetCsvTemplate = (id: CsvTemplateId, enabled = true) =>
  useQuery(
    [CsvTemplateQueryKeys.GET_CSV_TEMPLATE, id],
    ({ signal }) => httpService.Get<GetCsvTemplateResponse>(`/csv-templates/${id}`, { signal }),
    {
      enabled,
      cacheTime: 30 * 60 * 1000,
      staleTime: 15 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  )

const mediaUploadImage = 'media/v1.0/image'
const mediaUploadDocument = 'media/v1.0/document'

export const uploadImage = async (file: any) => {
  const formData = new FormData()
  const result = await imageCompresser(file)
  formData.append('file', result)

  try {
    const response = await httpService.Put(`${BASE_API_URL}${mediaUploadImage}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response
  } catch (error) {
    const axiosError = error as AxiosError
    if (axiosError?.response && axiosError.response.data) {
      return axiosError.response.data
    } else {
      console.error('An unexpected error occurred:', error)
      return { status: 500, body: 'An unexpected error occurred' }
    }
  }
}

export const uploadDocument = async (file: any) => {
  const formData = new FormData()
  formData.append('file', file)

  try {
    const response = await httpService.Put(`${BASE_API_URL}${mediaUploadDocument}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response
  } catch (error) {
    const axiosError = error as AxiosError
    if (axiosError?.response && axiosError.response.data) {
      return axiosError.response.data
    } else {
      console.error('An unexpected error occurred:', error)
      return { status: 500, body: 'An unexpected error occurred' }
    }
  }
}

export const inviteMembersCSV = async (clubId: string, file: any) => {
  const formData = new FormData()
  formData.append('request', file)

  try {
    const response = await httpService.Put(`${BASE_API_URL}club/${clubId}/members/v1.0/csv/add`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return { status: 200, body: response }
  } catch (error) {
    return { body: error }
  }
}

export const verifyMatchesCSV = async (clubId: string, file: any, dateFormat: string = 'yyyy-MM-dd') => {
  const formData = new FormData()
  formData.append('request', file)
  try {
    // Append the dateFormat as a query parameter to the URL
    const response = await httpService.Put(
      `${BASE_API_URL}club/${clubId}/match/verified/v1.0/save/csv/add?dateFormat=${dateFormat}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    return response
  } catch (error) {
    const axiosError = error as AxiosError
    if (axiosError?.response && axiosError.response.data) {
      return axiosError.response.data
    } else {
      console.error('An unexpected error occurred:', error)
      return { status: 500, body: 'An unexpected error occurred' }
    }
  }
}
